export interface Sponsor {
  name: string;
  image: string;
  link: string;
}

export const TITLE_SPONSORS: Sponsor[] = [
  { name: 'John Deere', image: 'jd.png', link: 'https://www.deere.com/en/' },
];

export const SPONSORS: Sponsor[] = [
  { name: 'Aeris', image: 'aeris.svg', link: 'https://www.aeris.com/' },
  { name: 'Bloomberg', image: 'bloomberg.png', link: 'https://www.bloomberg.com/' },
  { name: 'Caterpillar', image: 'caterpillar.png', link: 'https://www.caterpillar.com/' },
  { name: 'Github', image: 'github.png', link: 'https://www.github.com' },
  { name: 'Grainger', image: 'grainger.svg', link: 'https://www.grainger.com/' },
  { name: 'Hudson River Trading', image: 'hrt.svg', link: 'https://www.hudsonrivertrading.com/' },
  { name: 'IMC', image: 'imc.svg', link: 'https://www.imc.com/us/' },
  { name: 'Meta', image: 'meta.png', link: 'https://about.facebook.com/meta/' },
  { name: 'Schlumberger', image: 'schlumberger.svg', link: 'https://www.slb.com/' },
  { name: 'Stripe', image: 'stripe.svg', link: 'https://stripe.com' },
  { name: 'Venture For America', image: 'vfa.svg', link: 'https://ventureforamerica.org/' },
  { name: 'Wayfair', image: 'wayfair.png', link: 'https://www.wayfair.com/' },
];
